import { useCallback, useMemo } from 'react';

import { PageHeaderDropdownMenu } from 'components/Page/Header/PageHeaderDropdownMenu';
import { LANGUAGES, LanguageLocale } from 'utils/constants';

import { LanguageSelectionMenuItem } from './LanguageSelectionMenuItem';
import { LanguageSelectionMenuTitle } from './LanguageSelectionMenuTitle';

type Props = {
  pageUrl: Record<LanguageLocale, string>;
};

export function LanguageSelectionMenu({ pageUrl }: Props) {
  const languageLocales = Object.keys(LANGUAGES) as LanguageLocale[];

  const languageLocalesToShow = useMemo(
    () => languageLocales.filter((key) => key !== CURRENT_LOCALE),
    [languageLocales]
  );

  const titleComponentFunction = useCallback(
    (open: boolean) => <LanguageSelectionMenuTitle open={open} />,
    []
  );

  return (
    <PageHeaderDropdownMenu
      hideArrow={{ lg: true }}
      title={titleComponentFunction}
      data-qa-id="language-dropdown"
      aria-label={getText('Select language')}
    >
      {languageLocalesToShow.map((locale) => (
        <LanguageSelectionMenuItem
          key={locale}
          languageLocale={locale}
          languageLocaleUrl={pageUrl[locale]}
        />
      ))}
    </PageHeaderDropdownMenu>
  );
}
